import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { toast } from "react-toastify";

const ViewBrBDDocuments = ({ show, handleClose }) => {
  const { user } = useAuth();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchData();
    }
  }, [show]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${Base_URL}/BRBD/GetBRBDData/${user?.organisationId}`
      );

      setData(res.data || []);
    } catch (err) {
      console.error("Error fetching BRBD data", err);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async(row) => {
    const res=await axios.post(`${Base_URL}/BRBD/InsertACHDACITBRBD/${row.brbdlGuid}/${user?.userId?.toString()}`);
    if(res.status===200)
    {
       toast.success("BRBD entry approved successfully!",`${row.brbdlGuid}`);
        fetchData();
    }
    else    {
      toast.error("Failed to approve BRBD entry!",`${row.brbdlGuid}`);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>View BRBD Documents</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner />
          </div>
        ) : (
          <Table bordered striped hover>
            <thead>
              <tr>
                
                <th>Statement ID</th>
                <th>Doc FY</th>
                <th>Amount</th>
                <th>Currency</th>
                <th>Head2</th>
                <th>Status</th>
                <th>GL</th>
                <th>Director</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                 
                  <td>{item.statementid}</td>
                  <td>{item.docfy}</td>
                  <td>{item.brbdAmount}</td>
                  <td>{item.brbdCurrency}</td>
                  <td>{item.brBdhead2}</td>
                  <td>{item.brBdStatus}</td>
                  <td>{item.brBdGl || "-"}</td>
                  <td>{item.directorName}</td>

                  <td>
                    <Button
                      size="sm"
                      variant="success"
                      onClick={() => handleApprove(item)}
                      disabled={item.brBdStatus === "Approved"}
                    >
                      Approve
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewBrBDDocuments;